module.exports = __webpack_public_path__ + "img/hr-garballo-11.47a6ae2a.png";